import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Feedback, TypeFeedbackEnum } from '@app/core/models';
import { SHARED_MODULES } from '@app/shared';
import { KeyboardShortcutsService } from '@app/shared/modules/keyboard-shortcuts/keyboard-shortcuts.service';

@Component({
  selector: 'app-modal-review-feedback-text',
  imports: [SHARED_MODULES],
  templateUrl: './modal-review-feedback-text.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalReviewFeedbackTextComponent implements OnInit {
  private keyboard = inject(KeyboardShortcutsService);
  private element = inject(ElementRef);
  @Output() public close = new EventEmitter<Feedback>();

  @ViewChild('inputTextArea', { static: true }) private _elementRef: ElementRef;
  private _limit = 240;
  public textCtrl = new FormControl(undefined, [Validators.maxLength(this.limit)]);
  private _feedback: any;

  constructor() {
    const targetLateralAlunos = this.element.nativeElement.querySelector('.aluno-observacoes-heading');
    this.keyboard.add([
      {
        key: ['shift + x', 'shift + X', 'ctrl + X'],
        command: () => this.onClose(),
        target: targetLateralAlunos,
        preventDefault: true,
      },
      {
        key: ['shift + enter'],
        command: () => this.onSave(),
        target: targetLateralAlunos,
        preventDefault: true,
      },
    ]);
  }

  public get limit(): number {
    return this._limit - (this.textCtrl?.value?.length || 0);
  }

  @Input('data') public set setData(feedback: any) {
    this._feedback = feedback;
    this.textCtrl.setValue(feedback?.description);
  }

  public ngOnInit() {
    this._elementRef.nativeElement.focus();
    // this.focusTipoObservacaoTexto();
  }

  public onClose() {
    this.close.emit();
  }

  public onSave() {
    if (this.textCtrl.invalid) {
      this.textCtrl.markAsTouched();
      return;
    }
    this.close.emit({ ...this._feedback, type: TypeFeedbackEnum.Text, description: this.textCtrl.value });
  }

  public focusTipoObservacaoTexto() {
    this._elementRef.nativeElement.focus();
  }

  public label(error: any): string {
    return `geral.erros.${error}`;
  }
}
